// Centralised image URLs (curated, optimised query params appended)
const opt = (url, w = 1600) => `${url}?auto=format&fit=crop&w=${w}&q=80`;

export const IMAGES = {
  heroAnalytics: opt('https://images.unsplash.com/photo-1551288049-bebda4e38f71', 1800),
  multifamily: opt('https://images.unsplash.com/photo-1612637968894-660373e23b03', 1400),
  commercial: opt('https://images.unsplash.com/photo-1651666176108-b04ad2125fd5', 1400),
  grid: opt('https://images.unsplash.com/photo-1413882353314-73389f63b6fd', 1600),
  solar: opt('https://images.unsplash.com/photo-1509391366360-2e959784a276', 1400),
  team: opt('https://images.unsplash.com/photo-1522071820081-009f0129c71c', 1400),
};

export default IMAGES;
